import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { EndpointsService } from './endpoints.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(
    private httpSrv: HttpService,
    private endpoints: EndpointsService,
  ) { }

  async sendingEventsApp(dataCustom: any) {
    const response = await firstValueFrom(this.httpSrv.post(this.endpoints.tag, dataCustom));
    return response;
  }
}
